import {Injectable} from "@angular/core";
import {map} from "rxjs/operators";
import {DataService} from "../shared/data.service";
import {EMPTY, of} from "rxjs";
import {ApiEndpoints} from "../shared/ApiEndpoints";

@Injectable()
export class UnitsService extends DataService{

  getItems() {
    return this.getRequest(ApiEndpoints.units);
  }

  getItem(id) {
    if (!id) {
      return of({error: 'ID is missing'});
    }
    return this.getRequest(`${ApiEndpoints.units}/${id}`)
  }

  saveItem(data){
    if (data.id) {
      return this.putRequest(`${ApiEndpoints.units}`, data);
    } else {
      return this.postRequest(`${ApiEndpoints.units}`, data);
    }
  }

  deleteItem(id){
    return this.deleteRequest(`${ApiEndpoints.units}`, id);
  }

}
